module.exports = __webpack_public_path__ + "img/top-bg-topic-list.96f15578.jpg";